<template>
<v-container>
   <v-card width="400" class="mx-auto mt-5">
		<v-card-title>
			<h1 class="display-1">Register </h1>
		</v-card-title>
		<v-card-text>
			<v-form ref="signUpForm" @submit.prevent="createUser" id='login-form'>
				<v-text-field 
					label="Full Name" 
					type="name"
					v-model="name"
					:rules="nameRules"
					required
					prepend-icon="mdi-account-circle" 
				/>				
                <v-text-field 
					label="Email" 
					type="email"
					v-model="email"
					:rules="emailRules"
					required
					prepend-icon="mdi-account-arrow-right" 
				/>

				<v-text-field
					label="Password"
					:type="showPassword ? 'text' : 'password'"
					v-model="password"
					:rules="passwordRules"
					prepend-icon="mdi-lock"
					:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
					@click:append="showPassword = !showPassword"
				/>
			</v-form>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-btn type="submit" color="success" form="login-form">Register</v-btn>
		</v-card-actions>
            <v-snackbar v-model="snackbar">
                {{ error }}
                <v-btn
                    color="pink"
                    text
                    @click="snackbar = false"
                >
                    Close
                </v-btn>
            </v-snackbar>
	</v-card>
    </v-container>
</template>


<script>
import firebase from "firebase";

export default {
    data: () =>  ({
        showPassword: false,
		email: '',
		emailRules: [
			value => !!value || 'Email is required.',
			value => value.indexOf('@') !== 0 || 'Email should have a username.',
			value => value.includes('@') || 'Email should include an @ symbol.',
			value =>
				value.indexOf('.') - value.indexOf('@') > 1 ||
				'Email should contain a valid domain.',
			value => value.includes('.') || 'Email should include a period symbol.',
			value =>
				value.indexOf('.') <= value.length - 3 ||
				'Email should contain a valid domain extension.'
		],
		password: '',
		passwordRules: [
			value => !!value || 'Password is required',
			value => value.length > 5 || 'Password should be at least six characters'
        ],
        name: '',
		nameRules: [
            value => !!value || 'Name is required',
            value => value.indexOf(' ') !== 0 || 'Full name should have at least first and last names.',
            value => value.includes(' ') || 'Full should have at least first and last names.',
            value => value.length > 5 || 'Name should be at least six characters'
        ],
        error: '',
        snackbar: false
	}),
  methods: {
    createUser() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(data => {
          data.user
            .updateProfile({
              displayName: this.name
            })
            .then(() => {
					this.$router.replace({ name: "dashboard" })
			})
        })
        .catch(err => {
          this.error = err.message;
          this.snackbar = true
        })
    }
  }
}
</script>